import { AxiosInstance } from 'axios';

import { TrackingAPIApiFactory } from '@cast/openapi-services';

import { AXIOS_CONFIGURATION } from '../constants';

export const TrackingApiFactory = (client: AxiosInstance) => {
  const trackingGeneratedApi = TrackingAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  return {
    getTrackingSession: trackingGeneratedApi.trackingAPIGetTrackingSession,
    listTrackingSessions: trackingGeneratedApi.trackingAPIListTrackingSessions,
  };
};
